import React, { useEffect, useReducer, useContext, useState } from "react";
import { Store } from "../../states/store";
import { reducer } from "../../states/reducers";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Card, Col, Container, Row } from "react-bootstrap";
import EditUserModel from "./EditUserModel.js";
import { FaEdit } from "react-icons/fa";
import { motion } from "framer-motion";
import Skeleton from "react-loading-skeleton";
import { MessageBox } from "../../components";
import { getUser } from "../../states/actions.js";

const ViewUser = () => {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { token, user } = state;
  const { id } = useParams();

  const [modalShow, setModalShow] = useState(false);
  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: true,
    error: "",
  });

  useEffect(() => {
    getUser(ctxDispatch, dispatch, token, id);
  }, [id]);

  function formatDate(dateString) {
    const date = new Date(dateString);

    // Get day, month, year
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    // Get hours and minutes
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Determine AM/PM suffix and adjust hours for 12-hour format
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return `${day}-${month}-${year} ${hours}:${minutes}${ampm}`;
  }

  return (
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: "0%" }}
      transition={{ duration: 0.75, ease: "easeInOut" }}
      exit={{ x: "100%" }}
    >
      <Container fluid className="py-3">
        {error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <>
            <Card>
              <Card.Header>
                <Card.Title>
                  {loading ? <Skeleton /> : user?.username} Details
                </Card.Title>

                <div className="card-tools">
                  <FaEdit
                    style={{ color: "blue" }}
                    onClick={() => setModalShow(true)}
                  />
                </div>
              </Card.Header>
              <Card.Body>
                <Row className="mb-3">
                  <Col md={4}>
                    {loading ? (
                      <Skeleton height={200} />
                    ) : (
                      <img
                        style={{
                          borderRadius: "5px",
                        }}
                        src={user?.avatar}
                        alt=""
                        className="img-fluid"
                        width={"200px"}
                        height={"200px"}
                      />
                    )}
                  </Col>
                  <Col md={12}>
                    <Row>
                      <Col md={3}>
                        <p className="mb-0">
                          <strong>User Name</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : user?.username}</p>
                      </Col>
                      <Col md={3}>
                        <p className="mb-0">
                          <strong>Email</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : user?.email}</p>
                      </Col>
                      <Col md={3}>
                        <p className="mb-0">
                          <strong>Mobile</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : user?.mobile_no}</p>
                      </Col>
                      <Col md={3}>
                        <p className="mb-0">
                          <strong>Gender</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : user?.gender}</p>
                      </Col>
                      <Col md={3}>
                        <p className="mb-0">
                          <strong>Country</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : user?.country}</p>
                      </Col>
                      <Col md={3}>
                        <p className="mb-0">
                          <strong>Role</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : user?.role}</p>
                      </Col>
                      <Col md={3}>
                        <p className="mb-0">
                          <strong>Date of Birth</strong>
                        </p>
                        <p>
                          {loading ? <Skeleton /> : user?.dob.split("T")[0]}
                        </p>
                      </Col>

                      <Col md={3}>
                        <p className="mb-0">
                          <strong>Created At</strong>
                        </p>
                        <p>
                          {loading ? <Skeleton /> : formatDate(user?.createdAt)}
                        </p>
                      </Col>
                      <Col md={3}>
                        <p className="mb-0">
                          <strong>Last Update</strong>
                        </p>
                        <p>
                          {loading ? <Skeleton /> : formatDate(user?.updatedAt)}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <EditUserModel
              show={modalShow}
              onHide={() => setModalShow(false)}
            />

            {!modalShow && <ToastContainer />}
          </>
        )}
      </Container>
    </motion.div>
  );
};

export default ViewUser;
